import React from 'react';
import { AlertTriangle } from 'react-feather';
import Page, { PageContentBodyGrid } from './layouts/Shared/Page/Page';
import { User } from 'react-feather';
import PageGridItem from './layouts/Shared/Page/PageGridItem';
import Button from './components/Buttons/Button';
import logoBlack from './images/3SKYE-logo-black.png'
import FlexWrapper from './layouts/FlexWrapper';
import "./layouts//NoPermissionsPage.scss";


const NoAccess = () => {

	const switchUser = () => window.location.href = '/sign-in';

	return (
		<Page noBanner>
			<PageContentBodyGrid id="error-message" style={{ gridTemplateRows: "1fr" }}>
				<PageGridItem style={{ height: "100%" }} colSpan="12">
					<FlexWrapper align="center" justify="center" direction="column" fullWidth style={{ height: "100%" }}>
						<img className='logo-black-dimenssions' src={logoBlack} alt="3skye logo" />
						<h1 className='welcome'>Welcome</h1>
						<p className='p-message'>{"You currently have no permissions to view this site. Please contact your software support."}</p>
						<Button icon={<User />} onClick={switchUser} style={{ height: 38 }}>Switch User</Button>
					</FlexWrapper>
				</PageGridItem>
			</PageContentBodyGrid>
		</Page>
	);
}

export default NoAccess;